var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SimpleDefer = /** @class */ (function () {
    function SimpleDefer() {
        var _this = this;
        this.state = 'pending';
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = function (arg) {
                _this.state = 'fulfilled';
                resolve(arg);
            };
            _this.reject = function (arg) {
                _this.state = 'rejected';
                reject(arg);
            };
        });
    }
    return SimpleDefer;
}());
export default SimpleDefer;
var TimeoutDefer = /** @class */ (function (_super) {
    __extends(TimeoutDefer, _super);
    function TimeoutDefer(config) {
        var _this = _super.call(this) || this;
        if (config.timeoutMS > 0) {
            setTimeout(function () { return _this.reject(); }, config.timeoutMS);
        }
        return _this;
    }
    return TimeoutDefer;
}(SimpleDefer));
export { TimeoutDefer };
